export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig();

  const fetchRequest = async (method, { url, body, headers, token }) => {
    if (!token) token = await nuxtApp.$msal?.acquireToken();
    if (!url.startsWith('/')) url = `/${url}`;

    const data = await $fetch(`${config.public.API_HOST}${url}`, {
      body,
      method,
      headers: {
        ...headers,
        ...(token && { Authorization: token }),
        'Ocp-Apim-Subscription-Key': config.public.API_OCP_APIM_SUBSCRIPTION_KEY
      }
    });
    return { data };
  };

  const fetchMethods = (token = null) => ({
    fetchGet: (url, headers) => fetchRequest('GET', { url, headers, token }),
    fetchPut: (url, body, headers) => fetchRequest('PUT', { url, body, headers, token }),
    fetchPost: (url, body, headers) => fetchRequest('POST', { url, body, headers, token }),
    fetchDelete: (url, body, headers) => fetchRequest('DELETE', { url, body, headers, token })
  });

  return {
    provide: {
      apiRequest: fetchMethods(),
      apiRequestManualToken: fetchMethods
    }
  };
});
